// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__SW0hx","wrapper":"Navbar_wrapper__gvXQ5","search":"Navbar_search__k2c9Q"};